import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app/services/store";

interface PrefetchMetadata {
  lastFetchTimestamp: number;
  firstRecordId: number | string | null;
}

interface State {
  metadata: Record<string, PrefetchMetadata>;
}

const initialState: State = {
  metadata: {},
};

export const prefetchMetadataSlice = createSlice({
  name: "prefetchMetadata",
  initialState,
  reducers: {
    updatePrefetchMetadata: (
      state,
      action: PayloadAction<{
        key: string;
        firstRecordId: number | string | null;
      }>,
    ) => {
      const { key, firstRecordId } = action.payload;
      state.metadata[key] = {
        lastFetchTimestamp: Date.now(),
        firstRecordId,
      };
    },
    clearPrefetchMetadata: (state, action: PayloadAction<string>) => {
      delete state.metadata[action.payload];
    },
  },
});

export const { updatePrefetchMetadata, clearPrefetchMetadata } =
  prefetchMetadataSlice.actions;

export const selectPrefetchMetadata = (state: RootState, key: string) =>
  state.prefetchMetadata?.metadata?.[key];

export default prefetchMetadataSlice.reducer;
